/** Public marketing copy for /custom-sites (non-technical). */

export const customSitesContent = {
  eyebrow: "Custom websites & applications",
  title: "Fast sites and apps your team actually owns.",
  lead:
    "Skip template lock-in. We build performance-first marketing sites, lightweight apps, and full web products - with brand-faithful design, a deploy pipeline you control, and an engineering team accountable for delivery.",
  heroPoints: [
    "Static, lightweight, or full application builds",
    "Self-host or run on Google Cloud, AWS, or Vercel",
    "Logging, alerts, CRM, and email hooks when you need them",
  ],
  features: [
    {
      id: "performance",
      title: "Built for speed at every scale",
      body:
        "From blazing static pages to lightweight apps and full web applications - picked for your traffic and roadmap, not a one-size WordPress theme.",
      icon: "performance",
    },
    {
      id: "brand",
      title: "Brand-faithful UI",
      body:
        "Layouts, typography, and components match how you present in person and in print - so the site feels like your business, not a generic skin.",
      icon: "brand",
    },
    {
      id: "ownership",
      title: "A codebase - and pipeline - you own",
      body:
        "Source in your repo, automated deploys, rollbacks, and environments you can see. No mystery hosting account you cannot move later.",
      icon: "ownership",
    },
    {
      id: "hosting",
      title: "Host where it makes sense",
      body:
        "Self-host on your hardware, or ship to Google Cloud, AWS, or Vercel - we design for your compliance, budget, and ops comfort.",
      icon: "hosting",
    },
  ],
  stacks: {
    title: "Modern stacks we ship with",
    frontends: ["React", "Next.js", "Vue", "Static HTML"],
    backends: ["Node", "Python", "PHP"],
  },
  engineering: {
    title: "An engineering team on the hook",
    body:
      "You get accountable builders - not a ticket queue lost in a theme shop. We scope, build, deploy, and support what we deliver.",
    points: [
      "Clear milestones from prototype to production",
      "Documented handoff so your staff can maintain or extend",
      "Ongoing fixes and feature work when you want a partner",
    ],
  },
  integrations: {
    title: "Connect to how you sell and support",
    body:
      "Wire in the tools your business already relies on - or plan them for phase two.",
    chips: [
      "Custom logging",
      "Notifications & alerts",
      "CRM",
      "Email & marketing",
    ],
  },
  deployHub: {
    title: "See builds and releases in one place",
    subtitle:
      "Sample view of how we track deploys, environments, and status - so you know what’s live without asking in chat.",
    projectName: "Your brand site",
    metrics: {
      environments: "3",
      lastDeploy: "2h ago",
      uptime: "99.9%",
    },
    active: [
      {
        id: "Production",
        state: "Live",
        snippet: "main @ a3f91c2 - marketing + pricing pages",
      },
      {
        id: "Staging",
        state: "Preview",
        snippet: "feature/contact-form - QA before promote",
      },
    ],
    recent: [
      {
        id: "Deploy #184",
        topic: "Production",
        outcome: "Success",
        response: "Cache purge + smoke tests passed",
        time: "2h ago",
      },
      {
        id: "Deploy #183",
        topic: "Staging",
        outcome: "Success",
        response: "CRM webhook integration verified",
        time: "Yesterday",
      },
      {
        id: "Deploy #182",
        topic: "Production",
        outcome: "Rolled back",
        response: "Reverted asset path; hotfix #181 promoted",
        time: "3 days ago",
      },
    ],
    liveBadge: "Healthy",
  },
  cta: {
    primary: "Plan your launch",
    secondary: "View pricing",
  },
};
